module.exports = __webpack_public_path__ + "img/ico_ck2.e567dce1.png";